const getters = {
  advertiserDetails: state => state.advertiserDetails,
  advertisers: state => state.advertisers,
  editableAdvertiserFields: state => state.editableAdvertiserFields,
  isAdvertisersLoading: state => state.isAdvertisersLoading,
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/advertiser/advertiser.getters.js